import { ISection } from '@sdk/contracts';
import React, { useMemo } from 'react';

import { SyncedIcon } from '@/components/SyncedIcon';

type Props = {
  section: ISection;
};

export const SectionName: React.FC<Props> = ({ section }) => {
  const { name, parentSection } = section;

  const showSyncedIcon = useMemo(() => {
    return parentSection || (section.syncedSections && section.syncedSections.length > 0);
  }, [parentSection, section.syncedSections]);

  return (
    <span style={{ fontSize: '20px', fontWeight: 600 }}>
      {name}
      {showSyncedIcon && (
        <span style={{ marginLeft: 6, display: 'inline-flex', verticalAlign: 'middle' }}>
          <SyncedIcon />
        </span>
      )}
    </span>
  );
};
